import EmailChannelTableHelper from "./email-channel-table-helper";

const EmailChannelHelpers = {
  TableMain: EmailChannelTableHelper,
};

export * from "./email-channel-types-helper";
export default EmailChannelHelpers;
